import React, {ChangeEvent, useState} from 'react';
import styles from './Input.module.css';

interface InputProps {
  aoAlterado: (valor: string) => void;
  label: string;
  placeholder: string;
  type:string;
}

const Input: React.FC<InputProps> = (props) => {
  const [senha, setSenha] = useState<string>('');

  const aoDigitado = (evento: ChangeEvent<HTMLInputElement>) => {
    const novoValor = evento.target.value;
    setSenha(novoValor);
    props.aoAlterado(novoValor);
  };

  return (
    <div className={styles.inputText}>
      <label>{props.label}</label>
      <input
        type={props.type}
        placeholder={props.placeholder}
        value={senha}
        onChange={aoDigitado}
      />
    </div>
  );
};

export default Input;
